import { all, fork, put, takeLatest, takeEvery, call } from 'redux-saga/effects';
import { SagaIterator } from '@redux-saga/core';
import {
    getTemples as getTemplesApi,
    addTemple as addTempleApi,
    getTempleDetails,
    updateTempleDetails,
    deleteTempleByIdApi,
    getApprovalRequests as getApprovalRequestsApi,
    updateApprovalRequest as updateApprovalRequestApi,
} from 'helpers/api/temples';
import { templeApiResponseSuccess, templeApiResponseError } from './actions';
import { TempleActionTypes } from './constants';

/**
 * Fetches temples from the API
 */
function* getTemples({
    payload: {
        limit,
        page,
        sortType,
        city,
        state,
        registrationStatus,
        templeType,
    },
}: any): SagaIterator {
    try {
        const response = yield call(getTemplesApi, {
            limit,
            page,
            sortType,
            city,
            state,
            registrationStatus,
            templeType,
        });

        const temples = response.data;
        yield put(
            templeApiResponseSuccess(
                TempleActionTypes.GET_TEMPLES,
                temples
            )
        );
    } catch (error: any) {
        console.log('Error fetching temples:', error);
        yield put(
            templeApiResponseError(
                TempleActionTypes.GET_TEMPLES,
                error
            )
        );
    }
}

function* addTempleSaga({ payload: templeDetails }: any): SagaIterator {

    console.log("addTempleSaga started");

    try {

        console.log("Calling API");

        const response = yield call(addTempleApi, templeDetails);

        console.log("API Success", response);

        const createdTemple = response.data;

        yield put(
            templeApiResponseSuccess(
                TempleActionTypes.ADD_TEMPLE,
                createdTemple
            )
        );

    } catch (error: any) {
        console.log("Saga Error", error);

        yield put(
            templeApiResponseError(
                TempleActionTypes.ADD_TEMPLE,
                error?.response?.message ||
                error?.message ||
                String(error)
            )
        );
    }
}

function* getTempleDetailsByIdSaga(action: any): SagaIterator {
    try {
        const response = yield call(getTempleDetails, action.payload);
        const templeDetails = response.data;
        yield put(templeApiResponseSuccess(TempleActionTypes.GET_TEMPLE_DETAILS, templeDetails));
    } catch (error: any) {
        yield put(templeApiResponseError(TempleActionTypes.GET_TEMPLE_DETAILS, error));
    }
}

function* updateTempleByIdSaga(action: any): SagaIterator {
    try {
        const response = yield call(updateTempleDetails, action.payload);
        const updatedTempleDetails = response.data;
        yield put(templeApiResponseSuccess(TempleActionTypes.UPDATE_TEMPLE, updatedTempleDetails));
    } catch (error: any) {
        yield put(templeApiResponseError(TempleActionTypes.UPDATE_TEMPLE, error));
    }
}

function* deleteTempleByIdSaga(action: any): SagaIterator {
    try {
        yield call(deleteTempleByIdApi, action.payload);
        yield put(
            templeApiResponseSuccess(
                TempleActionTypes.DELETE_TEMPLE,
                action.payload
            )
        );
    } catch (error: any) {
        yield put(templeApiResponseError(TempleActionTypes.DELETE_TEMPLE, 'Failed to delete Temple'));
    }
}

function* getApprovalRequestsSaga(action: any): SagaIterator {
    try {
        const response = yield call(
            getApprovalRequestsApi,
            action.payload
        );

        yield put(
            templeApiResponseSuccess(
                TempleActionTypes.GET_APPROVAL_REQUESTS,
                response.data
            )
        );
    } catch (error: any) {
        yield put(
            templeApiResponseError(
                TempleActionTypes.GET_APPROVAL_REQUESTS,
                error?.message || String(error)
            )
        );
    }
}

function* updateApprovalRequestSaga(action: any): SagaIterator {
    try {
        const { requestId, status, remarks } = action.payload;

        const response = yield call(
            updateApprovalRequestApi,
            requestId,
            { status, remarks }
        );

        yield put(
            templeApiResponseSuccess(
                TempleActionTypes.UPDATE_APPROVAL_REQUEST,
                response.data
            )
        );
    } catch (error: any) {
        yield put(
            templeApiResponseError(
                TempleActionTypes.UPDATE_APPROVAL_REQUEST,
                error?.message || String(error)
            )
        );
    }
}

export function* watchGetTemples() {
    yield takeLatest(TempleActionTypes.GET_TEMPLES, getTemples);
}

export function* watchAddTemple() {
    yield takeEvery(TempleActionTypes.ADD_TEMPLE, addTempleSaga);
}

export function* watchUpdateTempleById() {
    yield takeEvery(TempleActionTypes.UPDATE_TEMPLE, updateTempleByIdSaga);
}

export function* watchGetTempleDetailsById() {
    yield takeLatest(TempleActionTypes.GET_TEMPLE_DETAILS, getTempleDetailsByIdSaga);
}

export function* watchDeleteTempleById() {
    yield takeEvery(TempleActionTypes.DELETE_TEMPLE, deleteTempleByIdSaga);
}

export function* watchGetApprovalRequests() {
    yield takeLatest(
        TempleActionTypes.GET_APPROVAL_REQUESTS,
        getApprovalRequestsSaga
    );
}

export function* watchUpdateApprovalRequest() {
    yield takeEvery(
        TempleActionTypes.UPDATE_APPROVAL_REQUEST,
        updateApprovalRequestSaga
    );
}

/**
 * Root temple saga
 */
function* templeSaga() {
    yield all([
        fork(watchGetTemples),
        fork(watchAddTemple),
        fork(watchGetTempleDetailsById),
        fork(watchUpdateTempleById),
        fork(watchDeleteTempleById),
        fork(watchGetApprovalRequests),
        fork(watchUpdateApprovalRequest),
    ]);
}

export default templeSaga;
